import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import { OrderByDelieryDayData } from "../../../../redux/interfaces/expedition.interface";

export const ordersByDeliveryDayTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Ruta",
    value: "ruta",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Punct de lucru",
    value: "punctLucru",
    minW: 200,
    withSearch: true,
  },
  {
    label: "Nr comenzi",
    value: "nrComenzi",
    minW: 125,
  },
  {
    label: "Luni",
    value: "luni",
    width: 50,
  },
  {
    label: "Marti",
    value: "marti",
    width: 50,
  },
  {
    label: "Miercuri",
    value: "miercuri",
    width: 50,
  },
  {
    label: "Joi",
    value: "joi",
    width: 50,
  },
  {
    label: "Vineri",
    value: "vineri",
    width: 50,
  },
  {
    label: "Sambata",
    value: "sambata",
    width: 50,
  },
  {
    label: "Duminica",
    value: "duminica",
    width: 50,
  },
];

export const getOrdersByDeliveryDayTableData: any = (
  ordersByDeliveryDayList: OrderByDelieryDayData[],
) =>
  ordersByDeliveryDayList?.map((order) => {
    return {
      id: `${order.ruta} ${order.punctLucru}`,
      crudData: order,
      data: [
        {
          title: order.ruta,
        },
        {
          title: order.punctLucru,
        },
        {
          title: order.nrComanda,
        },
        {
          badges: [
            {
              badgeText: order.luni ? "*" : "",
              badgeColor: "light-success",
              style: { minWidth: "20px" },
            },
          ],
        },
        {
          badges: [
            {
              badgeText: order.marti ? "*" : "",
              badgeColor: "light-success",
              style: { minWidth: "20px" },
            },
          ],
        },
        {
          badges: [
            {
              badgeText: order.miercuri ? "*" : "",
              badgeColor: "light-success",
              style: { minWidth: "20px" },
            },
          ],
        },
        {
          badges: [
            {
              badgeText: order.joi ? "*" : "",
              badgeColor: "light-success",
              style: { minWidth: "20px" },
            },
          ],
        },
        {
          badges: [
            {
              badgeText: order.vineri ? "*" : "",
              badgeColor: "light-success",
              style: { minWidth: "20px" },
            },
          ],
        },
        {
          badges: [
            {
              badgeText: order.sambata ? "*" : "",
              badgeColor: "light-success",
              style: { minWidth: "20px" },
            },
          ],
        },
        {
          badges: [
            {
              badgeText: order.duminica ? "*" : "",
              badgeColor: "light-success",
              style: { minWidth: "20px" },
            },
          ],
        },
      ],
    };
  });
